<template>
  <div>
    <UploadImageArea
      :title="title"
      :appLabelText="appLabelText"
      :appLabelVariant="appLabelVariant"
      @clickCamera="startCamera"
      @clickSelect="startFileSelect"
    >
      <slot />
    </UploadImageArea>

    <SetImageModal
      v-show="isSetImageModalOpen"
      ref="setImageModal"
      :photographingType="photoGraphingType"
      v-model:isCameraActive="isCameraActiveValue"
      :isFrontCamera="isFrontCamera"
      :options="options"
      :modalType="modalType"
      @closeModal="closeSetImageModal"
      @openModal="openSetImageModal"
      @input="onInputImageData"
      @changeImage="openSetImageModal"
      roundedButton
      :imageDescription="imageDescription"
    />
  </div>
</template>

<script lang="ts">
import AppButtonOutline from "@/components/atoms/button/AppButtonOutline.vue";
import AvatarImage from "@/components/molecules/other/AvatarImage.vue";
import SetImageModal from "@/components/molecules/other/SetImageModal.vue";
import UploadImageArea from "@/components/molecules/other/UploadImageArea.vue";
import { ModalType, PhotographingType } from "@/types/photo";
import { Component, Prop, Ref, Vue } from "vue-facing-decorator";

@Component({
  components: {
    AppButtonOutline,
    UploadImageArea,
    AvatarImage,
    SetImageModal
  }
})
export default class UploadImageForm extends Vue {
  @Prop({
    type: String,
    default: "写真アップロード"
  })
  title!: string;

  @Prop({
    type: String,
    required: true
  })
  photoGraphingType!: PhotographingType;

  @Prop({
    type: Boolean,
    default: true
  })
  isFrontCamera!: boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  isCameraActive!: boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean;

  @Prop({
    type: String,
    default: ""
  })
  disabledText!: string;

  @Prop({
    type: Array,
    required: true
  })
  options!: string[];

  @Prop({
    type: String,
    default: ""
  })
  appLabelText!: string;

  @Prop({
    type: String,
    default: "red"
  })
  appLabelVariant!: string;

  @Prop({
    type: String,
    default: ""
  })
  imageDescription!: string;

  @Ref() setImageModal!: SetImageModal;

  modalType: ModalType = "camera";
  isSetImageModalOpen = false;

  get isCameraActiveValue() {
    return this.isCameraActive;
  }

  set isCameraActiveValue(v) {
    this.$emit("update:isCameraActive", v);
  }

  startCamera() {
    if (this.disabled) {
      this.openDisabledModal();
      return;
    }
    this.modalType = "camera";
    this.setImageModal.startCamera();
  }

  startFileSelect() {
    if (this.disabled) {
      this.openDisabledModal();
      return;
    }
    this.modalType = "select";
    this.setImageModal.startFileSelect();
  }

  openDisabledModal() {
    this.$bvModal.msgBoxOk(this.disabledText, {
      centered: true
    });
  }

  closeSetImageModal() {
    this.isSetImageModalOpen = false;
  }

  openSetImageModal() {
    this.isSetImageModalOpen = true;
  }

  onInputImageData(imageData: string) {
    this.$emit("input", imageData);
  }
}
</script>
